import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import StoreBadges from "@/components/StoreBadges";
import { SUPPORT_EMAIL } from "@/config";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-divider bg-surface">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-3">
      <div>
        <p className="font-display text-xl font-bold uppercase tracking-[1.5px] text-onsurface">
          Sell<span className="text-brand-light">craft</span>
        </p>
        <p className="mt-3 font-display text-sm font-semibold uppercase tracking-widest text-brand-light">Snap. Price. Sell.</p>
        <p className="mt-4 max-w-xs text-sm text-onsurface2">
          Turn a photo into a ready-to-post marketplace listing in seconds.
        </p>
      </div>

      <nav aria-label="Footer" className="flex flex-col gap-3">
        <p className="font-display text-sm font-semibold uppercase tracking-widest text-onsurface">Company</p>
        <Link data-testid="footer-privacy-link" to="/privacy" className="text-sm text-onsurface2 transition-colors hover:text-brand-light">Privacy Policy</Link>
        <Link data-testid="footer-terms-link" to="/terms" className="text-sm text-onsurface2 transition-colors hover:text-brand-light">Terms of Service</Link>
        <Link data-testid="footer-support-link" to="/support" className="text-sm text-onsurface2 transition-colors hover:text-brand-light">Support</Link>
        <Link data-testid="footer-blog-link" to="/blog" className="text-sm text-onsurface2 transition-colors hover:text-brand-light">Blog</Link>
        <a data-testid="footer-email-link" href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 text-sm text-onsurface2 transition-colors hover:text-brand-light">
          <Mail className="h-4 w-4" /> {SUPPORT_EMAIL}
        </a>
      </nav>

      <div className="flex flex-col items-start gap-4">
        <p className="font-display text-sm font-semibold uppercase tracking-widest text-onsurface">Download</p>
        <StoreBadges testIdPrefix="footer" compact />
      </div>
    </div>
    <div className="border-t border-divider">
      <p className="mx-auto max-w-6xl px-4 py-6 text-xs text-onsurface2 sm:px-6">
        © {new Date().getFullYear()} Sellcraft. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
